import { User, UserInfo } from "@/types";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import { login } from "@/utils/demo-api";
import {
  getUser,
  getToken,
  setToken,
  setUser,
  cleanSession
} from "@/utils/app-util";

import DataLogin from "@/services/DataLogin";
import { use } from "chai";

export interface UserState {
  callingAPI: boolean;
  searching: string;
  // user: User;
  token: string;
  // mode: string;
  userInfo: UserInfo;
  signedIn: boolean;
}

@Module({ store, dynamic: true, name: "userModule" })
class UserModule extends VuexModule implements UserState {
  public callingAPI = false;
  public searching = "";
  user = getUser();
  token = getToken();

  public userInfo = {} as UserInfo;
  public signedIn = false;

  get isSignedIn(): boolean {
    return this.user.id && this.token ? true : false;
  }

  @Mutation
  private loginLoading() {
    this.callingAPI = !this.callingAPI;
  }
  @Mutation
  private globalSearching() {
    this.searching = this.searching === "" ? "loading" : "";
  }

  @Mutation
  private SET_USER(_user: User): void {
    this.user = _user;
  }

  @Mutation
  private SET_TOKEN(_token: string) {
    this.token = _token;
  }

  @Mutation
  private setUserInfo(_userInfo: UserInfo) {
    this.userInfo = _userInfo;
  }

  // @Action({ rawError: true })
  // public async signIn(userInfo: { username: string; password: string }) {
  //   const { username, password } = userInfo;
  //   const { data } = await login("login", { username, password });
  //   setToken(data.accessToken);
  //   setUser(JSON.stringify(data.user));
  //   console.log('dt', data)

  //   this.setToken(data.accessToken);
  //   this.setUser(data.user);
  // }

  @Action({ rawError: true })
  logout() {
    this.SET_TOKEN("");
    this.SET_USER({} as User);
    cleanSession();
  }

  @Action({ rawError: true })
  public async signIn(userInfo: {
    username: string;
    password: string;
    // unit: string;
    // unit_id: string;
    // zona: string;
  }) {
    console.log(userInfo)

    // const { username, password, unit, unit_id, zona } = userInfo;
    // const { data } = await login("login", {
    //   username,
    //   password,
    //   unit,
    //   unit_id,
    //   zona
    // });
    const { username, password} = userInfo;
    const { data } = await login("login", {
      username,
      password,
    });
    // console.log("data2")
    // console.log("wawa ",data)
    setToken(data.token);
    setUser(JSON.stringify(data.user));
    this.SET_USER(data.user);
    this.SET_TOKEN(data.token);
  }
}

export const userModule = getModule(UserModule);
